import { useTranslation } from "react-i18next";
import Dialog from "src/components/Dialog";
import { ReactComponent as MicrophoneIcon } from "./microphone.svg";

export default function MicrophonePermissionDialog({
  isOpen,
  onDismiss,
  openSettings
}) {
  const { t } = useTranslation();
  return (
    <Dialog
      icon={MicrophoneIcon}
      iconBg="primaryLight"
      iconFill="primary"
      buttons={[
        { text: t("buttons.cancel"), onClick: onDismiss },
        { text: t("settings"), onClick: openSettings }
      ]}
      heading={t("app.microphonePermissionDialog.heading")}
      text={t("app.microphonePermissionDialog.text")}
      isOpen={isOpen}
    />
  );
}
